import React, { useContext, Fragment } from "react";
import propTypes from "prop-types";
import CapacityBar from "../../locationTree/CapacityBar";
import { AssetLocation, AssetLocationTypes, KeyManagementTypes } from "../../../logic/api";
import flex from "../../../styles/flex";
import { ITreeViewAttachment, TreeViewContext } from "../TreeView";
import LocationNodeDataDisplay from './LocationNodeDataDisplay';

import { usePreferences } from '../../../utility/usePreferences';
import { ReleaseFlag, useReleaseManagement } from "../../../utility/feature-management";

const keyCountTypes = new Set([
    AssetLocationTypes.Keyroom,
    AssetLocationTypes.Hook,
    AssetLocationTypes.KeyLocker,
    AssetLocationTypes.KeyLockerBox,
    AssetLocationTypes.Users,
    AssetLocationTypes.User,
    AssetLocationTypes.KeyBox,
    AssetLocationTypes.DynamicBox,
]);

const vehicleCountTypes = new Set([
    AssetLocationTypes.CarPark,
    AssetLocationTypes.Zone,
    AssetLocationTypes.Lane,
]);

const getCountValues = (location: AssetLocation) => {
    if (keyCountTypes.has(location.type)) {
        return {
            assetCount: location.keyCount,
            assetCountTotal: location.keyCountTotal,
        };
    }

    if (vehicleCountTypes.has(location.type)) {
        return {
            assetCount: location.vehicleCount,
            assetCountTotal: location.vehicleCountTotal,
        };
    }

    return {
        assetCount: 0,
        assetCountTotal: 0,
    };
}

const LocationNodeAttachment: React.FunctionComponent<ITreeViewAttachment> = (props) => {
    const { displayMixedLaneWarning, displayNextMovementDate } = usePreferences();
    const tvc = useContext(TreeViewContext);

    const location: AssetLocation = props.record as AssetLocation;
    const { blockPark, earliestCheckoutDate, isMixedLane } = location;
    const isDynamicBox = location.type == AssetLocationTypes.DynamicBox;

    const dataDisplayProps = { displayMixedLaneWarning, displayNextMovementDate, blockPark, earliestCheckoutDate, isMixedLane }
    const { assetCount, assetCountTotal } = getCountValues(location);

    const displayPercentageFlag = Boolean(tvc.state?.flags?.displayPercentage);

    const hideCapacityFlag = isDynamicBox && displayPercentageFlag;

    return <Fragment>
        <LocationNodeDataDisplay {...dataDisplayProps} />
        {location.keyType != KeyManagementTypes.inherit && (
            <Fragment>
                <div style={flex.flexAuto}>
                    <div style={{ paddingRight: 10, fontWeight: "bold", color: "blue" }}>
                        <small>{KeyManagementTypes[location.keyType].toString().toUpperCase()}</small>
                    </div>
                </div>
            </Fragment>
        )}
        {(location.capacity || assetCount || !location.hasChildren) && (
            <div style={flex.flexAuto}>
                {!hideCapacityFlag && <CapacityBar total={location.capacity} value={assetCount} displayPercentage={displayPercentageFlag} assetLocationType={location.type}></CapacityBar>}
            </div>
        )}
        {location.hasChildren && (
            <Fragment>
                <div style={flex.flexAuto}>
                    <CapacityBar total={location.capacityTotal} value={assetCountTotal} displayPercentage={displayPercentageFlag} assetLocationType={location.type}></CapacityBar>
                </div>
            </Fragment>
        )}
    </Fragment>
}
LocationNodeAttachment.propTypes = {
    record: propTypes.any.isRequired
}
export default LocationNodeAttachment;
